import { AiAgentV2Data } from '../../../../types/AiAgentV2';
import { MarkDownEditorComponent } from '../MarkDownEditor';
import { MessagesBot, TextType } from './MarkdownChatComponent';
import TableMessageComponent from './TableMessageComponent';
import ChatChartComponent, { ChatChartType } from './ChatChartComponent';
import { cn } from '../../../../lib/utils';
import React from 'react';

const WaitingComponent = () => (
    <svg className="w-[30px] fill-primary" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <circle cx="4" cy="12" r="3">
            <animate
                id="spinner_qFRN"
                begin="0;spinner_OcgL.end+0.25s"
                attributeName="cy"
                calcMode="spline"
                dur="0.6s"
                values="12;6;12"
                keySplines=".33,.66,.66,1;.33,0,.66,.33"
            />
        </circle>
        <circle cx="12" cy="12" r="3">
            <animate
                begin="spinner_qFRN.begin+0.1s"
                attributeName="cy"
                calcMode="spline"
                dur="0.6s"
                values="12;6;12"
                keySplines=".33,.66,.66,1;.33,0,.66,.33"
            />
        </circle>
        <circle cx="20" cy="12" r="3">
            <animate
                id="spinner_OcgL"
                begin="spinner_qFRN.begin+0.2s"
                attributeName="cy"
                calcMode="spline"
                dur="0.6s"
                values="12;6;12"
                keySplines=".33,.66,.66,1;.33,0,.66,.33"
            />
        </circle>
    </svg>
);

export function WrapperMessage(props: { className?: string; children: React.ReactNode }) {
    const { className = 'w-[fit-content] ' } = props;
    return <div className={cn('bg-white shadow rounded-[10px] px-5 py-2', className)}>{props.children}</div>;
}

export function FormatMessage({ message }: { message: MessagesBot; data: AiAgentV2Data }) {

    switch (message.type) {
        case TextType.CHART:
            return message.content.meta?.chart_type  ? (
                <WrapperMessage className="w-full bg-transparent shadow-none">
                    <ChatChartComponent
                        type={message.content.meta?.chart_type as ChatChartType}
                        chartData={message.content}
                    />
                </WrapperMessage>
            ) : null;

        case TextType.TABLE:
            return (
                <WrapperMessage className="w-full">
                    <TableMessageComponent data={message.content} />
                </WrapperMessage>
            );

        case TextType.WAITING:
            return (
                <WrapperMessage>
                    <WaitingComponent />
                </WrapperMessage>
            );

        case TextType.CODE:
            return (
                <WrapperMessage>
                    <code className="text-[11px] ">{message.content.data}</code>
                </WrapperMessage>
            );

        default:
            return (
                <WrapperMessage>
                    <MarkDownEditorComponent markdown={message.content.text} readonly />
                </WrapperMessage>
            );
    }
}
